import React from "react";

/* Reusable surface panel matching the command-center aesthetic. */
export function Panel({ className = "", children, hover = false, ...props }) {
  return (
    <div
      className={`bg-[var(--surface)] border border-[var(--bd)] rounded-lg ${
        hover ? "transition-colors duration-200 hover:border-[var(--bd-strong)]" : ""
      } ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <span className={`uppercase tracking-[0.2em] text-[10px] font-bold text-[var(--t2)] ${className}`}>
      {children}
    </span>
  );
}
